(function () {
  "use strict";

  var doc = document;
  var root = doc.documentElement;
  root.classList.add("js-ready");
  var header = doc.querySelector("[data-site-header]");
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Product sticky navigation ----------------------------------------- */
  function initProductStickyNav(scope) {
    var navs = (scope || doc).querySelectorAll("[data-product-sticky-nav]");
    navs.forEach(function (nav) {
      if (nav.dataset.stickyReady === "true") return;
      nav.dataset.stickyReady = "true";

      var links = Array.prototype.slice.call(nav.querySelectorAll("[data-sticky-link]"));
      var targets = links.map(function (link) {
        var href = link.getAttribute("href") || "";
        if (href.charAt(0) !== "#") return null;
        try { return doc.querySelector(href); } catch (error) { return null; }
      }).filter(Boolean);

      links.forEach(function (link) {
        link.addEventListener("click", function () {
          links.forEach(function (item) { item.classList.remove("is-active"); });
          link.classList.add("is-active");
        });
      });

      if (!targets.length || !("IntersectionObserver" in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; });
        if (!visible.length) return;
        visible.sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
        var id = "#" + visible[0].target.id;
        links.forEach(function (link) {
          link.classList.toggle("is-active", link.getAttribute("href") === id);
        });
      }, { rootMargin: "-22% 0px -58% 0px", threshold: [0, 0.08, 0.25] });
      targets.forEach(function (target) { observer.observe(target); });
    });
  }

  initProductStickyNav(doc);
  doc.addEventListener("shopify:section:load", function (event) { initProductStickyNav(event.target); });

  /* Factory video ------------------------------------------------------ */
  function initFactoryVideos(scope) {
    var videos = (scope || doc).querySelectorAll(".factory-video");
    videos.forEach(function (wrap) {
      if (wrap.dataset.videoReady === "true") return;
      var video = wrap.querySelector("video");
      var toggle = wrap.querySelector("[data-factory-video-toggle]");
      if (!video || !toggle) return;
      wrap.dataset.videoReady = "true";
      wrap.classList.add("has-video");
      toggle.addEventListener("click", function () {
        video.play().then(function () {
          wrap.classList.add("is-playing");
        }).catch(function () {
          video.controls = true;
        });
      });
      video.addEventListener("play", function () { wrap.classList.add("is-playing"); });
      video.addEventListener("pause", function () { wrap.classList.remove("is-playing"); });
      video.addEventListener("ended", function () {
        wrap.classList.remove("is-playing");
        video.currentTime = 0;
      });
    });
  }

  initFactoryVideos(doc);
  doc.addEventListener("shopify:section:load", function (event) { initFactoryVideos(event.target); });

  /* Homepage Story video ---------------------------------------------- */
  function initStoryVideos(scope) {
    var stories = (scope || doc).querySelectorAll("[data-story-video-wrap]");
    stories.forEach(function (wrap) {
      if (wrap.dataset.storyVideoReady === "true") return;
      var video = wrap.querySelector("[data-story-video]");
      var toggle = wrap.querySelector("[data-story-video-toggle]");
      if (!video || !toggle) return;
      wrap.dataset.storyVideoReady = "true";

      toggle.addEventListener("click", function () {
        video.controls = true;
        video.play().then(function () {
          wrap.classList.add("is-playing");
        }).catch(function () {
          video.controls = true;
        });
      });

      video.addEventListener("play", function () { wrap.classList.add("is-playing"); });
      video.addEventListener("ended", function () {
        wrap.classList.remove("is-playing");
        video.controls = false;
        video.currentTime = 0;
      });
    });
  }

  initStoryVideos(doc);
  doc.addEventListener("shopify:section:load", function (event) { initStoryVideos(event.target); });

  function refreshScrollTriggers() {
    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === "function") {
      window.ScrollTrigger.refresh();
    }
  }

  /* Sticky header state -------------------------------------------------- */
  if (header) {
    var scrollFrame = 0;
    var updateHeader = function () {
      scrollFrame = 0;
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    };

    updateHeader();
    window.addEventListener("scroll", function () {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateHeader);
    }, { passive: true });
  }

  /* Header panels ------------------------------------------------------- */
  var panelTriggers = Array.prototype.slice.call(doc.querySelectorAll("[data-panel-toggle]"));
  var panels = Array.prototype.slice.call(doc.querySelectorAll("[data-header-panel]"));
  var lastPanelTrigger = null;

  function triggersFor(panelId) {
    return panelTriggers.filter(function (trigger) {
      return trigger.getAttribute("data-panel-toggle") === panelId;
    });
  }

  function closePanels(options) {
    var settings = options || {};
    panels.forEach(function (panel) {
      if (panel._hideTimer) window.clearTimeout(panel._hideTimer);
      var wasVisible = !panel.hidden;
      panel.classList.remove("is-open");
      triggersFor(panel.id).forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      });
      if (!wasVisible || reduceMotion) {
        panel.hidden = true;
      } else {
        panel._hideTimer = window.setTimeout(function () {
          panel.hidden = true;
          panel._hideTimer = 0;
        }, 230);
      }
    });
    if (header) header.classList.remove("has-open-panel");
    if (settings.restoreFocus && lastPanelTrigger) lastPanelTrigger.focus();
    lastPanelTrigger = null;
  }

  function openPanel(panelId, trigger, moveFocus) {
    var panel = doc.getElementById(panelId);
    if (!panel) return;
    var alreadyOpen = !panel.hidden;
    closePanels();
    closeMobileMenu();
    if (alreadyOpen) return;

    lastPanelTrigger = trigger;
    if (panel._hideTimer) window.clearTimeout(panel._hideTimer);
    panel._hideTimer = 0;
    panel.hidden = false;
    triggersFor(panelId).forEach(function (item) {
      item.setAttribute("aria-expanded", "true");
    });
    if (header) header.classList.add("has-open-panel");
    window.requestAnimationFrame(function () {
      panel.classList.add("is-open");
      if (moveFocus) {
        var firstControl = panel.querySelector(".shop-signin")
          || panel.querySelector("[data-panel-close], a[href], button:not([disabled])");
        if (firstControl) firstControl.focus({ preventScroll: true });
      }
    });
  }

  panelTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      openPanel(trigger.getAttribute("data-panel-toggle"), trigger, event.detail === 0);
    });
  });

  doc.querySelectorAll("[data-panel-close]").forEach(function (button) {
    button.addEventListener("click", function () {
      closePanels({ restoreFocus: true });
    });
  });

  /* Mobile navigation --------------------------------------------------- */
  var menuToggle = doc.querySelector("[data-menu-toggle]");
  var mobileNav = doc.getElementById("mobile-nav");

  function closeMobileMenu() {
    if (!menuToggle || !mobileNav) return;
    menuToggle.setAttribute("aria-expanded", "false");
    menuToggle.setAttribute("aria-label", "Open menu");
    mobileNav.hidden = true;
    if (header && !panels.some(function (panel) { return !panel.hidden; })) {
      header.classList.remove("has-open-panel");
    }
  }

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      var willOpen = menuToggle.getAttribute("aria-expanded") !== "true";
      closePanels();
      menuToggle.setAttribute("aria-expanded", String(willOpen));
      menuToggle.setAttribute("aria-label", willOpen ? "Close menu" : "Open menu");
      mobileNav.hidden = !willOpen;
      if (header) header.classList.toggle("has-open-panel", willOpen);
    });

    mobileNav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMobileMenu);
    });

    var desktopNavigation = window.matchMedia("(min-width: 1041px)");
    var syncMobileMenuBreakpoint = function (event) {
      if (event.matches) closeMobileMenu();
    };
    if (typeof desktopNavigation.addEventListener === "function") {
      desktopNavigation.addEventListener("change", syncMobileMenuBreakpoint);
    } else {
      desktopNavigation.addListener(syncMobileMenuBreakpoint);
    }
  }

  doc.addEventListener("click", function (event) {
    if (event.target.closest("[data-panel-toggle], [data-menu-toggle]")) return;
    if (header && !header.contains(event.target)) {
      closePanels();
      closeMobileMenu();
    }
  });

  doc.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closePanels({ restoreFocus: true });
      closeMobileMenu();
    }
  });

  if (header) {
    header.addEventListener("focusout", function () {
      window.requestAnimationFrame(function () {
        var openPanelElement = panels.find(function (panel) { return panel.classList.contains("is-open"); });
        if (!openPanelElement) return;
        var activeTrigger = triggersFor(openPanelElement.id).some(function (trigger) {
          return trigger === doc.activeElement;
        });
        if (!openPanelElement.contains(doc.activeElement) && !activeTrigger) closePanels();
      });
    });
  }

  /* Footer region selector opens in place instead of reusing the header panel. */
  doc.querySelectorAll("[data-footer-region-selector]").forEach(function (selector) {
    var toggle = selector.querySelector("[data-footer-region-toggle]");
    var menu = selector.querySelector("[data-footer-region-menu]");
    if (!toggle || !menu) return;
    function closeFooterRegion() {
      toggle.setAttribute("aria-expanded", "false");
      menu.hidden = true;
    }
    toggle.addEventListener("click", function (event) {
      event.stopPropagation();
      var open = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", String(open));
      menu.hidden = !open;
    });
    menu.addEventListener("click", function (event) { event.stopPropagation(); });
    doc.addEventListener("click", closeFooterRegion);
    doc.addEventListener("keydown", function (event) { if (event.key === "Escape") closeFooterRegion(); });
  });

  /* Regional stores: the current store is fixed by the site host. Other
   * stores are plain links that navigate away — nothing is remembered on
   * this device, so each store always shows its own region as selected. */
  var storeOptions = Array.prototype.slice.call(doc.querySelectorAll("[data-store-key]"));
  var configuredStores = Array.isArray(window.FIBRESEEK_STORES) ? window.FIBRESEEK_STORES : [];

  function getCurrentStoreKey() {
    var matchingStore = configuredStores.find(function (store) {
      if (!store || !store.url) return false;
      try { return new URL(store.url, window.location.href).host === window.location.host; }
      catch (error) { return false; }
    });
    return (matchingStore && matchingStore.key) || window.FIBRESEEK_DEFAULT_STORE ||
      (configuredStores[0] && configuredStores[0].key) || "us";
  }

  function markActiveStore(key) {
    if (!key) return;
    storeOptions.forEach(function (item) {
      var active = item.getAttribute("data-store-key") === key;
      item.classList.toggle("is-active", active);
      item.setAttribute("aria-pressed", String(active));
      if (active) {
        var label = item.getAttribute("data-store-label");
        var flagImg = item.getAttribute("data-store-flagimg");
        var name = item.getAttribute("data-store-name");
        if (label) {
          doc.querySelectorAll("[data-region-label]").forEach(function (el) { el.textContent = label; });
        }
        doc.querySelectorAll("[data-region-flag]").forEach(function (el) {
          if (flagImg && el.tagName === "IMG") el.src = flagImg;
        });
        if (name) {
          triggersFor("region-panel").forEach(function (trigger) {
            trigger.setAttribute("aria-label", "Choose store: " + name);
          });
        }
      }
    });
  }

  var arrivedWithStoreChoice = false;
  function normalizeStoreChoice(value) {
    var aliases = { "1": "us", "2": "au", "3": "de", "4": "uk", "gb": "uk" };
    var key = String(value || "").toLowerCase();
    key = aliases[key] || key;
    return configuredStores.some(function (store) { return store.key === key; }) ? key : "";
  }
  // Preserve existing query parameters and fragments on every regional link.
  storeOptions.forEach(function (item) {
    if (item.tagName !== "A" || !item.getAttribute("href")) return;
    var key = normalizeStoreChoice(item.getAttribute("data-store-key"));
    if (!key) return;
    try {
      var target = new URL(item.getAttribute("href"), window.location.href);
      if (target.protocol !== "https:" && target.protocol !== "http:") return;
      target.searchParams.set("region", key);
      item.href = target.href;
    } catch (error) { /* Keep the server-rendered link. */ }
  });

  (function initStoreChoice() {
    var params = new URLSearchParams(window.location.search);
    var regionParam = normalizeStoreChoice(params.get("region") || params.get("store"));
    arrivedWithStoreChoice = regionParam === getCurrentStoreKey();
    if (arrivedWithStoreChoice) {
      try { window.localStorage.setItem("fibreseek-region-chosen", String(regionParam)); } catch (error) { /* optional */ }
    }
    if (params.has("region") || params.has("store")) {
      params.delete("region");
      params.delete("store");
      var clean = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
      if (window.history && window.history.replaceState) window.history.replaceState(null, "", clean);
    }
    markActiveStore(getCurrentStoreKey());
  })();

  /* Cart quantity badge — red circle on the cart icon, synced on load. */
  (function initCartCountBadge() {
    var badge = doc.querySelector("[data-cart-count]");
    if (!badge) return;
    function render(count) {
      var n = Number(count) || 0;
      badge.textContent = String(n);
      badge.hidden = n <= 0;
    }
    try {
      fetch("/cart.js").then(function (res) { return res.ok ? res.json() : null; }).then(function (cart) {
        if (cart && typeof cart.item_count === "number") render(cart.item_count);
      }).catch(function () { /* optional */ });
    } catch (error) { /* optional */ }
    doc.addEventListener("shopify:section:load", function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector("[data-cart-count]")) {
        try {
          fetch("/cart.js").then(function (res) { return res.ok ? res.json() : null; }).then(function (cart) {
            if (cart && typeof cart.item_count === "number") render(cart.item_count);
          }).catch(function () { /* optional */ });
        } catch (error) { /* optional */ }
      }
    });
  })();

  /* Region overlay: welcome dialog once per browser session. Closing it
   * only dismisses — the current store stays selected. */
  var regionOverlay = doc.querySelector("[data-region-overlay]");
  function setRegionChoicePending(pending) {
    doc.documentElement.classList.toggle("fibreseek-region-pending", Boolean(pending));
  }
  var regionChosen = arrivedWithStoreChoice;
  try { regionChosen = regionChosen || window.localStorage.getItem("fibreseek-region-chosen"); } catch (error) { /* optional */ }
  if (regionOverlay && !regionChosen && storeOptions.length > 0 && !(window.Shopify && window.Shopify.designMode)) {
    setRegionChoicePending(true);
    regionOverlay.hidden = false;
    window.requestAnimationFrame(function () { regionOverlay.classList.add("is-open"); });
  }
  doc.querySelectorAll("[data-region-overlay-close]").forEach(function (button) {
    button.addEventListener("click", function () {
      setRegionChoicePending(false);
      regionOverlay.classList.remove("is-open");
      window.setTimeout(function () { regionOverlay.hidden = true; }, 320);
      try { window.localStorage.setItem("fibreseek-region-chosen", "dismissed"); } catch (error) { /* optional */ }
      window.dispatchEvent(new CustomEvent("fibreseek:region-ready"));
    });
  });

  /* Official Shopify Forms registration overlay -------------------------
   * The theme owns only presentation, timing and dismissal. Form fields,
   * validation, submission and customer data remain inside Shopify Forms. */
  function initRegistrationOverlay(scope) {
    var overlays = [];
    if (scope && scope.matches && scope.matches("[data-registration-overlay]")) overlays.push(scope);
    if (scope && scope.querySelectorAll) overlays = overlays.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-registration-overlay]")));

    overlays.forEach(function (overlay) {
      if (overlay.dataset.registrationReady === "true") return;
      /* The section owns the show/hide decision: when its "Show popup on
         site entry" setting is off, the markup carries data-auto-open=false
         and the overlay never opens automatically. */
      if (overlay.getAttribute("data-auto-open") === "false") return;
      overlay.dataset.registrationReady = "true";

      var overlayId = overlay.getAttribute("data-overlay-id") || "default";
      var storageKey = "fibreseek-registration-overlay:" + overlayId;
      var rememberSession = overlay.getAttribute("data-remember-session") === "true";
      var delayMs = Math.max(0, Number(overlay.getAttribute("data-delay") || 0)) * 1000;
      var closeButtons = Array.prototype.slice.call(overlay.querySelectorAll("[data-registration-overlay-close]"));
      var previousFocus = null;
      var openTimer = 0;

      function dismissalIsActive() {
        if (!rememberSession) return false;
        try {
          return window.sessionStorage.getItem(storageKey) === "1";
        } catch (error) { /* storage is optional */ }
        return false;
      }

      function rememberDismissal() {
        if (!rememberSession) return;
        try {
          window.sessionStorage.setItem(storageKey, "1");
        } catch (error) { /* storage is optional */ }
      }

      function openOverlay() {
        if (dismissalIsActive() || overlay.classList.contains("is-open")) return;
        previousFocus = doc.activeElement;
        overlay.hidden = false;
        doc.documentElement.classList.add("fibreseek-registration-open");
        window.requestAnimationFrame(function () {
          overlay.classList.add("is-open");
          var closeButton = overlay.querySelector(".registration-overlay-close");
          if (closeButton) closeButton.focus({ preventScroll: true });
        });
      }

      function closeOverlay(remember) {
        if (remember) rememberDismissal();
        overlay.classList.remove("is-open");
        doc.documentElement.classList.remove("fibreseek-registration-open");
        window.setTimeout(function () { overlay.hidden = true; }, 320);
        if (previousFocus && previousFocus.focus) previousFocus.focus({ preventScroll: true });
      }

      function scheduleOpen() {
        if (dismissalIsActive()) return;
        window.clearTimeout(openTimer);
        openTimer = window.setTimeout(openOverlay, delayMs);
      }

      closeButtons.forEach(function (button) {
        button.addEventListener("click", function () { closeOverlay(true); });
      });
      overlay.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeOverlay(true);
      });

      if (doc.documentElement.classList.contains("fibreseek-region-pending")) {
        window.addEventListener("fibreseek:region-ready", scheduleOpen, { once: true });
      } else {
        scheduleOpen();
      }
    });
  }

  initRegistrationOverlay(doc);
  doc.addEventListener("shopify:section:load", function (event) { initRegistrationOverlay(event.target); });

  /* Product gallery ------------------------------------------------------ */
  function initProductGalleries(scope) {
    var galleries = [];
    if (scope && scope.matches && scope.matches("[data-product-gallery]")) galleries.push(scope);
    if (scope && scope.querySelectorAll) galleries = galleries.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-product-gallery]")));

    galleries.forEach(function (gallery) {
    if (gallery.dataset.galleryReady === "true") return;
    gallery.dataset.galleryReady = "true";
    var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-product-slide]"));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-dot]"));
    var currentSlide = 0;
    var autoplayTimer = 0;
    var autoplay = gallery.getAttribute("data-gallery-autoplay") === "true";
    var autoplayDelay = Math.max(2000, Number(gallery.getAttribute("data-gallery-interval") || 5) * 1000);

    function showProductSlide(index) {
      if (!slides.length) return;
      currentSlide = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentSlide;
        slide.hidden = !active;
        slide.classList.toggle("is-active", active);
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === currentSlide;
        dot.classList.toggle("is-active", active);
        if (active) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
    }
    gallery.__showProductSlide = showProductSlide;

    var previous = gallery.querySelector("[data-gallery-prev]");
    var next = gallery.querySelector("[data-gallery-next]");
    function restartAutoplay() {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      if (!autoplay || slides.length < 2 || reduceMotion) return;
      autoplayTimer = window.setInterval(function () { showProductSlide(currentSlide + 1); }, autoplayDelay);
    }
    if (previous) previous.addEventListener("click", function () { showProductSlide(currentSlide - 1); restartAutoplay(); });
    if (next) next.addEventListener("click", function () { showProductSlide(currentSlide + 1); restartAutoplay(); });
    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () { showProductSlide(index); restartAutoplay(); });
    });
    showProductSlide(0);
    restartAutoplay();
    gallery.addEventListener("mouseenter", function () { if (autoplayTimer) window.clearInterval(autoplayTimer); });
    gallery.addEventListener("mouseleave", restartAutoplay);
    });
  }

  initProductGalleries(doc);

  /* Shopify product / variant data -------------------------------------- */
  function initProductDetails(scope) {
    var details = [];
    if (scope && scope.matches && scope.matches("[data-product-detail]")) details.push(scope);
    if (scope && scope.querySelectorAll) details = details.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-product-detail]")));

    details.forEach(function (detail) {
      if (detail.dataset.productReady === "true") return;
      detail.dataset.productReady = "true";

      var variantData = detail.querySelector("[data-product-variants]");
      if (!variantData) return;
      var variants = [];
      try { variants = JSON.parse(variantData.textContent || "[]"); } catch (error) { return; }
      if (!variants.length) return;

      var form = detail.querySelector("form.product-detail-form");
      var variantSelect = detail.querySelector("[data-product-variant-select]");
      var optionGroups = Array.prototype.slice.call(detail.querySelectorAll("[data-product-option-group]"));
      var variantInput = detail.querySelector("[data-selected-variant-id]");
      var price = detail.querySelector("[data-product-price]");
      var priceRow = detail.querySelector("[data-product-price-row]");
      var compare = detail.querySelector("[data-product-compare]");
      var save = detail.querySelector("[data-product-save]");
      var inventory = detail.querySelector("[data-product-inventory]");
      var sku = detail.querySelector("[data-product-sku]");
      var skuRow = sku ? sku.closest(".product-sku") : null;
      var barcode = detail.querySelector("[data-product-barcode]");
      var barcodeRow = barcode ? barcode.closest(".product-barcode") : null;
      var quantity = detail.querySelector("[data-product-quantity]");
      var addButton = detail.querySelector("[data-add-to-cart]");
      var gallery = detail.querySelector("[data-product-gallery]");

      function findVariant(id) {
        return variants.find(function (variant) { return String(variant.id) === String(id); }) || variants[0];
      }

      function findVariantByOptions(options) {
        return variants.find(function (variant) {
          if (!Array.isArray(variant.options) || variant.options.length !== options.length) return false;
          return variant.options.every(function (value, index) { return String(value) === String(options[index]); });
        });
      }

      function syncOptionLegends(selectedOptions) {
        optionGroups.forEach(function (group) {
          var position = Number(group.getAttribute("data-option-position") || 0);
          var valueTarget = group.querySelector("[data-selected-option-value]");
          if (valueTarget) valueTarget.textContent = selectedOptions[position] || "";
        });
      }

      function reconcileOptionAvailability() {
        var selectedOptions = [];

        optionGroups.forEach(function (group) {
          var position = Number(group.getAttribute("data-option-position") || 0);
          var inputs = Array.prototype.slice.call(group.querySelectorAll("[data-product-option-input]"));

          inputs.forEach(function (input) {
            var canSelect = variants.some(function (variant) {
              if (!variant.available || !Array.isArray(variant.options) || String(variant.options[position]) !== String(input.value)) return false;
              for (var previous = 0; previous < position; previous += 1) {
                if (selectedOptions[previous] !== undefined && String(variant.options[previous]) !== String(selectedOptions[previous])) return false;
              }
              return true;
            });
            input.disabled = !canSelect;
          });

          var checked = inputs.find(function (input) { return input.checked; });
          if (!checked || checked.disabled) {
            var firstAvailable = inputs.find(function (input) { return !input.disabled; });
            if (firstAvailable) {
              firstAvailable.checked = true;
              checked = firstAvailable;
            }
          }
          if (checked) selectedOptions[position] = checked.value;
        });

        syncOptionLegends(selectedOptions);
        return selectedOptions;
      }

      function showVariantMedia(mediaId) {
        if (!gallery || !mediaId || typeof gallery.__showProductSlide !== "function") return;
        var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-product-slide]"));
        var mediaIndex = slides.findIndex(function (slide) { return String(slide.getAttribute("data-media-id")) === String(mediaId); });
        if (mediaIndex >= 0) gallery.__showProductSlide(mediaIndex);
      }

      function applyVariant(variant, updateUrl) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (price) price.textContent = variant.priceFormatted || "";
        if (priceRow) priceRow.hidden = Number(variant.price || 0) <= 0;

        var hasCompare = Number(variant.compareAtPrice || 0) > Number(variant.price || 0);
        if (compare) {
          compare.hidden = !hasCompare;
          compare.textContent = hasCompare ? (variant.compareAtPriceFormatted || "") : "";
        }
        if (save) {
          save.hidden = !hasCompare;
          save.textContent = hasCompare ? ((save.getAttribute("data-save-label") || "Save") + " " + (variant.savingFormatted || "")) : "";
        }

        if (inventory) {
          var inStockLabel = inventory.getAttribute("data-in-stock-label") || "In stock";
          var outOfStockLabel = inventory.getAttribute("data-out-of-stock-label") || "Out of stock";
          var lowStockText = inventory.getAttribute("data-low-stock-text") || "Only [count] left";
          var threshold = Number(inventory.getAttribute("data-low-stock-threshold") || 0);
          var displayMode = inventory.getAttribute("data-display-mode") || "always";
          var showCount = inventory.getAttribute("data-show-count") === "true";
          var tracked = Boolean(variant.inventoryManagement);
          var invQuantity = Number(variant.inventoryQuantity || 0);
          var isLow = tracked && threshold > 0 && Boolean(variant.available) && invQuantity > 0 && invQuantity <= threshold;
          inventory.classList.toggle("is-available", Boolean(variant.available));
          inventory.classList.toggle("is-low", isLow);
          if (displayMode === "hidden") {
            inventory.hidden = true;
          } else if (displayMode === "low_only" && !isLow && Boolean(variant.available)) {
            inventory.hidden = true;
          } else {
            inventory.hidden = false;
            if (!variant.available) {
              inventory.textContent = outOfStockLabel;
            } else if (isLow) {
              inventory.textContent = lowStockText.replace("[count]", String(invQuantity));
            } else {
              inventory.textContent = inStockLabel;
              if (showCount && tracked && invQuantity > 0) {
                inventory.textContent += " (" + invQuantity + ")";
              }
            }
          }
        }

        if (sku) {
          sku.textContent = variant.sku || "";
          if (skuRow) skuRow.hidden = !variant.sku;
        }

        if (barcode) {
          barcode.textContent = variant.barcode || "";
          if (barcodeRow) barcodeRow.hidden = !variant.barcode;
        }

        if (quantity) {
          quantity.disabled = !variant.available;
          if (variant.inventoryManagement && variant.inventoryPolicy === "deny" && Number(variant.inventoryQuantity) > 0) quantity.max = variant.inventoryQuantity;
          else quantity.removeAttribute("max");
        }

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? (addButton.getAttribute("data-available-label") || "Add to cart") : (addButton.getAttribute("data-sold-out-label") || "Sold out");
        }

        showVariantMedia(variant.featuredMediaId);
        if (updateUrl && window.history && window.history.replaceState) {
          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set("variant", variant.id);
          window.history.replaceState({ variantId: variant.id }, "", nextUrl.toString());
        }
        if (form) form.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant: variant } }));
      }

      if (optionGroups.length) {
        optionGroups.forEach(function (group) {
          group.addEventListener("change", function (event) {
            if (!event.target.matches("[data-product-option-input]")) return;
            var selectedOptions = reconcileOptionAvailability();
            var selectedVariant = findVariantByOptions(selectedOptions);
            if (selectedVariant) applyVariant(selectedVariant, true);
          });
        });
        var initialOptions = reconcileOptionAvailability();
        var initialVariant = findVariantByOptions(initialOptions);
        applyVariant(initialVariant || findVariant(variantInput ? variantInput.value : variants[0].id), false);
      } else if (variantSelect) {
        variantSelect.addEventListener("change", function () { applyVariant(findVariant(variantSelect.value), true); });
        applyVariant(findVariant(variantSelect.value), false);
      } else {
        applyVariant(findVariant(variantInput ? variantInput.value : variants[0].id), false);
      }
    });
  }

  initProductDetails(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    initProductGalleries(event.target);
    initProductDetails(event.target);
  });

  /* Pre-order countdown --------------------------------------------------- */
  var countdownTimers = new WeakMap();

  function countdownNodes(scope) {
    var nodes = [];
    if (scope && scope.matches && scope.matches("[data-countdown]")) nodes.push(scope);
    if (scope && scope.querySelectorAll) {
      nodes = nodes.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-countdown]")));
    }
    return nodes;
  }

  function clearCountdowns(scope) {
    countdownNodes(scope).forEach(function (countdown) {
      var timer = countdownTimers.get(countdown);
      if (timer) window.clearInterval(timer);
      countdownTimers.delete(countdown);
      countdown.removeAttribute("data-countdown-ready");
    });
  }

  function initCountdowns(scope) {
    countdownNodes(scope || doc).forEach(function (countdown) {
      if (countdown.hasAttribute("data-countdown-ready")) return;
      countdown.setAttribute("data-countdown-ready", "true");

      var target = Date.parse(countdown.getAttribute("data-countdown") || "");
      if (!target) {
        countdown.hidden = true;
        countdown.setAttribute("data-countdown-error", "invalid-date");
        return;
      }

      countdown.hidden = false;
      countdown.removeAttribute("data-countdown-error");
      var parts = {
        d: countdown.querySelector("[data-cd-days]"),
        h: countdown.querySelector("[data-cd-hours]"),
        m: countdown.querySelector("[data-cd-minutes]"),
        s: countdown.querySelector("[data-cd-seconds]")
      };
      function pad(value) { return String(value).padStart(2, "0"); }
      var countdownTimer = 0;

      function tick() {
        var left = Math.max(0, target - Date.now());
        var secs = Math.floor(left / 1000);
        if (parts.d) parts.d.textContent = pad(Math.floor(secs / 86400));
        if (parts.h) parts.h.textContent = pad(Math.floor((secs % 86400) / 3600));
        if (parts.m) parts.m.textContent = pad(Math.floor((secs % 3600) / 60));
        if (parts.s) parts.s.textContent = pad(secs % 60);
        if (left <= 0) {
          countdown.classList.add("is-ended");
          var timerContent = countdown.querySelector("[data-countdown-timer]");
          var endContent = countdown.querySelector("[data-countdown-end-content]");
          if (timerContent) timerContent.hidden = true;
          countdown.querySelectorAll("[data-countdown-running]").forEach(function (item) { item.hidden = true; });
          var countdownHero = countdown.closest("[data-hero-slide]") || countdown.closest(".hero");
          if (countdownHero) {
            countdownHero.querySelectorAll("[data-countdown-presale-content]").forEach(function (item) { item.hidden = true; });
          }
          if (endContent) endContent.hidden = false;
          if (countdownTimer) window.clearInterval(countdownTimer);
          countdownTimers.delete(countdown);
        }
      }

      tick();
      if (target > Date.now()) {
        countdownTimer = window.setInterval(tick, 1000);
        countdownTimers.set(countdown, countdownTimer);
      }
    });
  }

  initCountdowns(doc);
  doc.addEventListener("shopify:section:load", function (event) { initCountdowns(event.target); });
  doc.addEventListener("shopify:section:unload", function (event) { clearCountdowns(event.target); });

  /* Accessible hero carousel ------------------------------------------- */
  var heroCarousel = doc.querySelector("[data-hero-carousel]");

  if (heroCarousel) {
    var heroSlides = Array.prototype.slice.call(heroCarousel.querySelectorAll("[data-hero-slide]"));
    var heroDots = Array.prototype.slice.call(heroCarousel.querySelectorAll("[data-hero-slide-to]"));
    var heroPagination = heroCarousel.querySelector(".hero-pagination");
    var heroAutoplayToggle = heroCarousel.querySelector("[data-hero-autoplay-toggle]");
    var heroPrevious = heroCarousel.querySelector("[data-hero-prev]");
    var heroNext = heroCarousel.querySelector("[data-hero-next]");
    var activeHeroSlide = Math.max(0, heroSlides.findIndex(function (slide) {
      return slide.classList.contains("is-active");
    }));
    var heroAutoplayTimer = 0;
    var heroPointerInside = false;
    var heroFocusInside = false;
    var heroFocusPlaybackOverride = false;
    var heroUserPaused = heroCarousel.getAttribute("data-autoplay") === "false";
    var heroAutoplayDelay = Number(heroCarousel.getAttribute("data-autoplay-delay")) || 6500;

    function stopHeroAutoplay() {
      if (!heroAutoplayTimer) return;
      window.clearTimeout(heroAutoplayTimer);
      heroAutoplayTimer = 0;
    }

    function startHeroAutoplay() {
      stopHeroAutoplay();
      if (reduceMotion || heroUserPaused || heroSlides.length < 2 || doc.hidden || heroPointerInside || (heroFocusInside && !heroFocusPlaybackOverride)) return;
      heroAutoplayTimer = window.setTimeout(function () {
        showHeroSlide(activeHeroSlide + 1);
        startHeroAutoplay();
      }, heroAutoplayDelay);
    }

    function syncHeroAutoplayToggle() {
      if (!heroAutoplayToggle) return;
      heroAutoplayToggle.classList.toggle("is-paused", heroUserPaused);
      heroAutoplayToggle.setAttribute("aria-label", heroUserPaused ? "Play slideshow" : "Pause slideshow");
    }

    function showHeroSlide(nextIndex) {
      if (!heroSlides.length) return;
      activeHeroSlide = (nextIndex + heroSlides.length) % heroSlides.length;

      heroSlides.forEach(function (slide, index) {
        var isActive = index === activeHeroSlide;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", String(!isActive));
      });

      heroDots.forEach(function (dot, index) {
        var isActive = index === activeHeroSlide;
        dot.classList.toggle("is-active", isActive);
        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }

    showHeroSlide(activeHeroSlide);
    syncHeroAutoplayToggle();

    if (heroAutoplayToggle) {
      heroAutoplayToggle.addEventListener("click", function () {
        heroUserPaused = !heroUserPaused;
        heroFocusPlaybackOverride = !heroUserPaused;
        syncHeroAutoplayToggle();
        if (heroUserPaused) stopHeroAutoplay();
        else startHeroAutoplay();
      });
    }

    heroDots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        showHeroSlide(Number(dot.getAttribute("data-hero-slide-to")) || 0);
        startHeroAutoplay();
      });
    });

    if (heroPrevious) {
      heroPrevious.addEventListener("click", function () {
        showHeroSlide(activeHeroSlide - 1);
        startHeroAutoplay();
      });
    }

    if (heroNext) {
      heroNext.addEventListener("click", function () {
        showHeroSlide(activeHeroSlide + 1);
        startHeroAutoplay();
      });
    }

    if (heroPagination) {
      heroPagination.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        showHeroSlide(activeHeroSlide + (event.key === "ArrowRight" ? 1 : -1));
        startHeroAutoplay();
      });
    }

    heroCarousel.addEventListener("mouseenter", function () {
      heroPointerInside = true;
      stopHeroAutoplay();
    });

    heroCarousel.addEventListener("mouseleave", function () {
      heroPointerInside = false;
      startHeroAutoplay();
    });

    heroCarousel.addEventListener("focusin", function (event) {
      heroFocusInside = true;
      if (event.target !== heroAutoplayToggle) heroFocusPlaybackOverride = false;
      stopHeroAutoplay();
    });

    heroCarousel.addEventListener("focusout", function () {
      window.requestAnimationFrame(function () {
        heroFocusInside = heroCarousel.contains(doc.activeElement);
        if (!heroFocusInside) heroFocusPlaybackOverride = false;
        startHeroAutoplay();
      });
    });

    doc.addEventListener("visibilitychange", function () {
      if (doc.hidden) stopHeroAutoplay();
      else startHeroAutoplay();
    });

    window.addEventListener("pagehide", stopHeroAutoplay);
    startHeroAutoplay();
  }

  /* Accessible accordion ------------------------------------------------ */
  var accordion = doc.querySelector(".accordion");

  function setAccordionItem(item, open, immediate) {
    var button = item.querySelector(".acc-head");
    var body = item.querySelector(".acc-body");
    if (!button || !body) return;

    button.setAttribute("aria-expanded", String(open));
    item.classList.toggle("open", open);

    if (immediate || !window.gsap || reduceMotion) {
      body.hidden = !open;
      body.style.height = "";
      body.style.opacity = "";
      return;
    }

    window.gsap.killTweensOf(body);
    if (open) {
      body.hidden = false;
      var targetHeight = body.scrollHeight;
      window.gsap.fromTo(body,
        { height: 0, autoAlpha: 0 },
        {
          height: targetHeight,
          autoAlpha: 1,
          duration: 0.42,
          ease: "power2.inOut",
          onComplete: function () {
            window.gsap.set(body, { clearProps: "height,opacity,visibility" });
            /*
             * No ScrollTrigger.refresh() here: with the page's
             * scroll-behavior: smooth, a refresh mis-measures the proof
             * parallax trigger and makes the left image snap. The accordion
             * height delta is only a few pixels, so skipping the refresh is
             * visually harmless; the next window resize re-refreshes anyway.
             */
          }
        }
      );
    } else {
      window.gsap.to(body, {
        height: 0,
        autoAlpha: 0,
        duration: 0.32,
        ease: "power2.inOut",
        onComplete: function () {
          body.hidden = true;
          window.gsap.set(body, { clearProps: "height,opacity,visibility" });
        }
      });
    }
  }

  if (accordion) {
    var accordionItems = Array.prototype.slice.call(accordion.querySelectorAll(".acc-item"));
    accordionItems.forEach(function (item) {
      var isOpen = item.classList.contains("open");
      setAccordionItem(item, isOpen, true);
      var button = item.querySelector(".acc-head");
      button.addEventListener("click", function () {
        if (item.classList.contains("open")) return;
        accordionItems.forEach(function (other) {
          setAccordionItem(other, other === item, false);
        });
      });
    });

    /*
     * Lock the accordion to its tallest open state while the proof grid is
     * two-column. Text wraps differently across platforms and font metrics,
     * so without the lock a taller tab grows the grid row mid-animation and
     * the proof image visibly rescales on every tab switch.
     */
    var lockAccordionHeight = function () {
      if (window.innerWidth <= 900) {
        accordion.style.minHeight = "";
        return;
      }
      var openIndex = 0;
      accordionItems.forEach(function (item, index) {
        if (item.classList.contains("open")) openIndex = index;
      });
      var max = 0;
      accordionItems.forEach(function (item, index) {
        accordionItems.forEach(function (other, otherIndex) {
          setAccordionItem(other, otherIndex === index, true);
        });
        max = Math.max(max, accordion.offsetHeight);
      });
      accordionItems.forEach(function (other, otherIndex) {
        setAccordionItem(other, otherIndex === openIndex, true);
      });
      accordion.style.minHeight = max + "px";
    };

    lockAccordionHeight();
    window.addEventListener("load", lockAccordionHeight);
    var lockResizeTimer;
    window.addEventListener("resize", function () {
      window.clearTimeout(lockResizeTimer);
      lockResizeTimer = window.setTimeout(lockAccordionHeight, 200);
    });
  }

  /* About hero: reveal the full company introduction on demand. -------- */
  doc.addEventListener("click", function (event) {
    var toggle = event.target.closest ? event.target.closest("[data-about-hero-toggle]") : null;
    if (!toggle) return;
    var shell = toggle.closest("[data-about-hero]");
    if (!shell) return;
    var panel = shell.querySelector("[data-about-hero-expanded]");
    if (!panel) return;
    var open = shell.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(open));
    panel.setAttribute("aria-hidden", String(!open));
    var label = toggle.querySelector("[data-about-hero-label]");
    if (label) {
      label.textContent = open ? toggle.dataset.closeLabel : toggle.dataset.openLabel;
    }
  });

  /* Apple-like motion system ------------------------------------------- */
  function initMotion() {
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger || reduceMotion) return;

    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    root.classList.add("gsap-active");

    if (doc.querySelector(".hero-slide.is-active .hero-media")) {
      var heroTimeline = gsap.timeline({ defaults: { ease: "power3.out" } });
      heroTimeline
        .fromTo(".hero-slide.is-active .hero-media", { autoAlpha: 0.72, scale: 1.035 }, {
          autoAlpha: 1,
          scale: 1,
          duration: 1.45,
          clearProps: "transform,opacity,visibility"
        })
        .fromTo(".hero-slide.is-active .hero-content > *", { autoAlpha: 0, y: 22 }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.82,
          stagger: 0.075,
          clearProps: "transform,opacity,visibility"
        }, 0.12);
    }

    if (doc.querySelector(".cards-grid")) {
      gsap.from(".p-card", {
        autoAlpha: 0,
        y: 34,
        scale: 0.992,
        duration: 0.9,
        stagger: 0.12,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".cards-grid", start: "top 88%", once: true }
      });
    }

    if (doc.querySelector(".story")) {
      gsap.from(".story-content > *", {
        autoAlpha: 0,
        y: 22,
        duration: 0.82,
        stagger: 0.08,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".story", start: "top 72%", once: true }
      });
    }

    if (doc.querySelector(".proof")) {
      gsap.from(".proof .section-title", {
        autoAlpha: 0,
        y: 22,
        duration: 0.8,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".proof", start: "top 84%", once: true }
      });
    }

    if (doc.querySelector(".proof-grid")) {
      gsap.from(".proof-card", {
        autoAlpha: 0,
        y: 28,
        scale: 0.994,
        duration: 0.95,
        stagger: 0.1,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".proof-grid", start: "top 86%", once: true }
      });
    }

    if (doc.querySelector(".why-grid")) {
      gsap.from(".why-item", {
        autoAlpha: 0,
        y: 18,
        duration: 0.7,
        stagger: 0.065,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".why-grid", start: "top 88%", once: true }
      });
    }

    if (doc.querySelector(".footer-nav")) {
      gsap.from(".footer-col", {
        autoAlpha: 0,
        y: 14,
        duration: 0.65,
        stagger: 0.04,
        ease: "power2.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".footer-nav", start: "top 92%", once: true }
      });
    }

    var motionMedia = gsap.matchMedia();
    motionMedia.add("(min-width: 901px)", function () {
      if (doc.querySelector(".hero")) {
        gsap.fromTo(".hero-bg", { yPercent: -1.5 }, {
          yPercent: 5.5,
          ease: "none",
          scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: 1.1 }
        });
        gsap.fromTo(".hero-content", { y: 0 }, {
          y: -24,
          ease: "none",
          scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: 1.2 }
        });
      }
      if (doc.querySelector(".story")) {
        gsap.fromTo(".story-bg", { yPercent: -3.5 }, {
          yPercent: 4.5,
          ease: "none",
          scrollTrigger: { trigger: ".story", start: "top bottom", end: "bottom top", scrub: 1.2 }
        });
      }
      if (doc.querySelector(".proof-card")) {
        gsap.fromTo(".proof-card-media img", { yPercent: -2.5 }, {
          yPercent: 3.5,
          ease: "none",
          scrollTrigger: { trigger: ".proof-card", start: "top bottom", end: "bottom top", scrub: 1.2 }
        });
      }
    });

    /* Product / About / Contact pages reuse the homepage motion language. */
    if (doc.querySelector(".product-detail-inner")) {
      gsap.from([".product-gallery", ".product-summary"], {
        autoAlpha: 0,
        y: 26,
        duration: 0.9,
        stagger: 0.12,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".product-detail-inner", start: "top 86%", once: true }
      });
    }

    if (doc.querySelector(".fs-media-banner__content, .fs-media-banner__stats")) {
      gsap.utils.toArray(".fs-media-banner__content, .fs-media-banner__stats").forEach(function (el) {
        gsap.from(el, {
          autoAlpha: 0,
          y: 24,
          duration: 0.85,
          ease: "power3.out",
          clearProps: "transform,opacity,visibility",
          scrollTrigger: { trigger: el, start: "top 88%", once: true }
        });
      });
    }

    if (doc.querySelector(".fs-media-grid__items")) {
      gsap.from(".fs-media-grid__items > *", {
        autoAlpha: 0,
        y: 20,
        duration: 0.75,
        stagger: 0.08,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".fs-media-grid__items", start: "top 88%", once: true }
      });
    }

    if (doc.querySelector(".product-story")) {
      gsap.from([".product-story-heading", ".product-story-visuals"], {
        autoAlpha: 0,
        y: 22,
        duration: 0.82,
        stagger: 0.1,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".product-story", start: "top 84%", once: true }
      });
    }

    if (doc.querySelector(".about-hero")) {
      gsap.fromTo(".about-hero-content > *", { autoAlpha: 0, y: 22 }, {
        autoAlpha: 1,
        y: 0,
        duration: 0.82,
        stagger: 0.075,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility"
      });
    }

    if (doc.querySelector(".about-building")) {
      gsap.from(".about-building", {
        autoAlpha: 0,
        y: 20,
        duration: 0.85,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".about-building", start: "top 90%", once: true }
      });
    }

    if (doc.querySelector(".about-era")) {
      gsap.from([".about-era .era-text", ".about-era .era-media"], {
        autoAlpha: 0,
        y: 26,
        duration: 0.9,
        stagger: 0.12,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".about-era", start: "top 84%", once: true }
      });
    }

    if (doc.querySelector(".about-factory")) {
      gsap.from(".about-factory", {
        autoAlpha: 0,
        y: 26,
        duration: 0.9,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".about-factory", start: "top 86%", once: true }
      });
    }

    if (doc.querySelector(".about-brands .about-container")) {
      gsap.from(".about-brands .about-container", {
        autoAlpha: 0,
        y: 24,
        duration: 0.85,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".about-brands", start: "top 86%", once: true }
      });
    }

    if (doc.querySelector(".about-values-card")) {
      gsap.from(".about-values-card", {
        autoAlpha: 0,
        y: 18,
        duration: 0.7,
        stagger: 0.08,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".about-values", start: "top 88%", once: true }
      });
    }

    if (doc.querySelector(".team-grid")) {
      gsap.from(".team-card", {
        autoAlpha: 0,
        y: 18,
        duration: 0.7,
        stagger: 0.07,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".team-grid", start: "top 88%", once: true }
      });
    }

    if (doc.querySelector(".contact-hero")) {
      gsap.fromTo(".contact-hero-content > *", { autoAlpha: 0, y: 22 }, {
        autoAlpha: 1,
        y: 0,
        duration: 0.82,
        stagger: 0.075,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility"
      });
    }

    if (doc.querySelector(".contact-map2")) {
      gsap.from(".contact-map2", {
        autoAlpha: 0,
        y: 24,
        duration: 0.85,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".contact-map2", start: "top 86%", once: true }
      });
    }

    if (doc.querySelector(".contact-form-section")) {
      gsap.from([".contact-form-card", ".contact-form-media"], {
        autoAlpha: 0,
        y: 26,
        duration: 0.9,
        stagger: 0.12,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".contact-form-section", start: "top 84%", once: true }
      });
    }

    if (doc.querySelector(".support-grid")) {
      gsap.from(".support-card", {
        autoAlpha: 0,
        y: 18,
        duration: 0.7,
        stagger: 0.08,
        ease: "power3.out",
        clearProps: "transform,opacity,visibility",
        scrollTrigger: { trigger: ".support-grid", start: "top 88%", once: true }
      });
    }

    doc.addEventListener("shopify:section:load", refreshScrollTriggers);
    doc.addEventListener("shopify:section:unload", refreshScrollTriggers);
  }

  if (doc.readyState === "complete") {
    initMotion();
  } else {
    window.addEventListener("load", initMotion, { once: true });
  }
})();
